<template>
    <b-form class="row" @submit.prevent="handleOk">
        <div class="col-12 text-right">
            <small class="text-muted">{{$t('personalInformation.requiredNote')}}</small>
        </div>
        <b-form-group
            class="col-12 col-sm-6"
            id="input-group-2"
            :label="$t('personalInformation.name') + ' *'"
            label-for="input-2"
            :description="submitStatus === 'ERROR' ? 'Ingresar datos requeridos':''">
            <b-form-input
                :disabled="$store.state.owner"
                @change="changeMode = true"
                :class="{'is-invalid':$v.name.$error, 'is-valid':!$v.name.$invalid}"
                id="input-2"
                size="sm"
                v-model.trim="$v.name.$model"
                ref="name"
                placeholder=""
            ></b-form-input>
        </b-form-group>
        <b-form-group
            class="col-12 col-sm-6"
            id="input-group-2"
            :label="$t('personalInformation.lastName') + ' *'"
            label-for="input-2"
            :description="submitStatus === 'ERROR' ? 'Ingresar datos requeridos':''">
            <b-form-input
                :disabled="$store.state.owner"
                @change="changeMode = true"
                :class="{'is-invalid':$v.lastname.$error, 'is-valid':!$v.lastname.$invalid}"
                id="input-2"
                size="sm"
                v-model="lastname"
                ref="lastname"
                placeholder=""
            ></b-form-input>
        </b-form-group>
        <b-form-group
            class="col-12 col-sm-6"
            id="input-age"
            :label="$t('personalInformation.age') + ' *'"
            label-for="age">
            <b-form-input
                :disabled="$store.state.owner"
                @change="changeMode = true"
                :class="{'is-invalid':$v.age.$error, 'is-valid':!$v.age.$invalid}"
                id="age"
                size="sm"
                v-model="age"
                ref="age"
                placeholder=""
            ></b-form-input>
        </b-form-group>
        <b-form-group
            class="col-12 col-sm-6"
            id="input-phone"
            :label="requiredFieldsConfig.phone ? $t('personalInformation.phone') + ' *' : $t('personalInformation.phone')"
            label-for="phone"
            :description="submitStatus === 'ERROR' ? 'Ingresar datos requeridos':''">
            <b-form-input
                :disabled="$store.state.owner"
                @change="changeMode = true"
                :class="{'is-invalid':$v.phone.$error, 'is-valid':!$v.phone.$invalid}"
                id="phone"
                size="sm"
                v-model="phone"
                ref="phone"
                placeholder=""
            ></b-form-input>
        </b-form-group>
        <b-form-group
            class="col-12 col-sm-6"
            id="input-email"
            :label="requiredFieldsConfig.email ? $t('personalInformation.email') + ' *' : $t('personalInformation.email')"
            label-for="email"
            :description="submitStatus === 'ERROR' ? 'Ingresar datos requeridos':''">
            <b-form-input
                :disabled="$store.state.owner"
                @change="changeMode = true"
                :class="{'is-invalid':$v.email.$error, 'is-valid':!$v.email.$invalid}"
                id="email"
                size="sm"
                v-model.trim="email"
                ref="email"
                placeholder=""
            ></b-form-input>
        </b-form-group>
        <h5 class="col-12 section-title">{{$t('address.titleAddress')}}</h5>
        <direccion ref="direccionComponent" @onChangeDirection="onChangeDirection" :update="direccionData" :required="requiredFieldsConfig.address" />
        <billing ref="billingComponent" @onChangeBilling="onChangeBilling" :update="billing ? billing : {
                                            name: name,
                                            lastName: lastname,
                                            age: age,
                                            email: email,
                                            phone: phone,
                                            country: country,
                                            city: city,
                                            state: state,
                                            zipCode: zipCode,
                                            address: address,
                                            address2: address2}"/>

        <h5 class="col-12 section-title">{{$t('documents.titleDocuments')}}</h5>
        <template v-if="$store.state.settings.showCurpMx">
            <b-form-group class="col-12">
                <b-form-checkbox
                    id="checkbox-mexican"
                    v-model="isMexican"
                    @change="changeMode = true"
                    :value="true"
                    :unchecked-value="false">
                    {{$t('personalInformation.isMexican')}}
                </b-form-checkbox>
            </b-form-group>
            <b-form-group
                v-if="isMexican"
                class="col-12 col-sm-6"
                id="input-curp"
                :label="$t('personalInformation.curp') + ' *'"
                label-for="curp">
                <b-form-input
                    :class="{'is-invalid':$v.curp.$error, 'is-valid':!$v.curp.$invalid}"
                    id="curp"
                    size="sm"
                    v-model.trim="curp"
                    @change="changeMode = true"
                    ref="curp"
                    style="text-transform:uppercase"
                ></b-form-input>
            </b-form-group>
        </template>
        <document-selection ref="documentSelection" @fileSelected="fileSelected" @onChangeDocument="onChangeDocument" :update="documentUpdate" :required="requiredFieldsConfig.document"/>
        <div v-if="typeFileSelection === 'ine_ife'" class="col-12">
            <h6 class="mt-3 mb-2">{{ requiredFieldsConfig.document ? $t('documents.file') + ' *' : $t('documents.file') }}</h6>
            <div class="row">
                <div class="col-12">
                    <file-upload :id="Number(ID)" :fileId="fileId ? fileId.find(({type}) => type === 'ine-front') : null" :hasDocument="hasDocument" ref="fileIneFront" :typeFile="$t('documents.ineFront')" fileTypeId="INE/IFE_front" :uploadError="uploadErrors.fileIneFront" @onChangeFIle="onChangeFileIneFront" @fileDeleted="fileDeleted"/>
                </div>
                <div class="col-12">
                    <file-upload :id="Number(ID)" :fileId="fileId ? fileId.find(({type}) => type === 'ine-back') : null" :hasDocument="hasDocument" ref="fileIneBack" :typeFile="$t('documents.ineBack')" fileTypeId="INE/IFE_back" :uploadError="uploadErrors.fileIneBack" @onChangeFIle="onChangeFileIneBack" @fileDeleted="fileDeleted"/>
                </div>
            </div>
        </div>
        <div v-if="typeFileSelection === 'pasaporte'" class="col-12">
            <h6 class="mt-3 mb-2">{{ requiredFieldsConfig.document ? $t('documents.file') + ' *' : $t('documents.file') }}</h6>
            <div class="row">
                <div class="col-12">
                    <file-upload :id="Number(ID)" :fileId="fileId ? fileId.find(({type}) => type === 'passport') : null" :hasDocument="hasDocument" ref="filepassport" :typeFile="$t('documents.passport')" fileTypeId="passport" :uploadError="uploadErrors.filepassport" @onChangeFIle="onChangeFilePassport" @fileDeleted="fileDeleted"/>
                </div>
            </div>
        </div>
        <div v-if="submitError" class="col-12 mt-2">
            <b-alert show variant="danger" class="mb-0">{{ submitError }}</b-alert>
        </div>
        <loading-overlay :active="isLoading" :is-full-page="true" />
    </b-form>
</template>

<script>
import Billing from './Billing'
import Direccion from './Direccion'
import DocumentSelection from './DocumentSelection'
import FileUpload from '@/components/bodycard/fileupload/FileUpload'
import { required, minValue, helpers, email as emailValidator } from 'vuelidate/lib/validators'
import { mapGetters, mapState } from 'vuex'
import requiredFieldsMixin from '@/mixins/requiredFieldsMixin'

const curpFormat = helpers.regex('curpFormat', /^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z0-9]\d$/)

export default {
    name: 'Modal',
    mixins: [requiredFieldsMixin],
    components: {
        Billing,
        Direccion,
        DocumentSelection,
        FileUpload
    },
    computed: {
        ...mapGetters(['getBookId','getBookData']),
        ...mapState(['bookData']),
    },
    data() {
        return {
            submitStatus: '',
            name: '',
            lastname: '',
            phone: '',
            email: '',
            age: 0,
            state:'',
            city: '',
            country: null,
            address: '',
            address2: '',
            zipCode: '',
            ID: null,
            direction: false,
            typeFileSelection: null,
            options: [
                { value: null, text: this.$t('documents.selectType') },
                { value: 'ine_ife', text: this.$t('documents.ine') },
                { value: 'pasaporte', text: this.$t('documents.passport') },
            ],
            isLoading: false,
            ineFileFront: null,
            ineFileBack: null,
            passportFile: null,
            changeMode: false,
            changeModeFile: false,
            hasDocument: false,
            billing: {},
            fileId: [],
            getBilling: null,
            direccionData: {},
            documentUpdate: {},
            disabledTypeFile: false,
            isMexican: false,
            curp: '',
            uploadErrors: {},
            uploadedTypes: [],
            signUploaded: false,
            savedGuest: null,
            submitError: null,
            isSubmitting: false,
        }
    },
    watch: {
        age: function(val){
            this.$emit('setAge', val )
        },
        // Una firma nueva (borrada y vuelta a dibujar) debe subirse de nuevo
        '$store.state.sign': function(){
            this.signUploaded = false
        }
    },
    validations() {
        const { email: emailRequired, phone: phoneRequired } = this.requiredFieldsConfig
        return {
            name: {
                required,
            },
            lastname: {
                required,
            },
            phone: phoneRequired ? { required } : {},
            email: emailRequired ? { required, email: emailValidator } : {},
            age: {
                required,
                minValue: minValue(1)
            },
            curp: this.$store.state.settings.showCurpMx && this.isMexican ? { required, curpFormat } : {},
        }
    },
    methods: {
        onChangeFileIneFront (file) {
            if(this.ineFileBack && file){
                this.hasDocument = true
            }else{
                this.hasDocument = false
            }
            this.changeModeFile = true
            this.ineFileFront = file
            this.resetUploadState('ineFileFront')
        },
        onChangeFileIneBack (file) {
            if(this.ineFileFront && file){
                this.hasDocument = true
            }else{
                this.hasDocument = false
            }
            this.changeModeFile = true
            this.ineFileBack=file
            this.resetUploadState('ineFileBack')
        },
        onChangeFilePassport (file) {
            if(file){
                this.hasDocument = true
            }else{
                this.hasDocument = false
            }
            this.changeModeFile = true
            this.passportFile = file
            this.resetUploadState('passportFile')
        },
        fileSelected (selected) {
            this.changeMode = true
            this.typeFileSelection = selected
            if(selected == 'ine_ife'){
                if(this.$refs.fileIneFront && this.$refs.fileIneFront.file){
                    this.$refs.fileIneFront.clearLocalFiles()
                }
                if(this.$refs.fileIneBack && this.$refs.fileIneBack.file){
                    this.$refs.fileIneBack.clearLocalFiles()
                }
            }else if(selected == 'pasaporte'){
                if(this.$refs.filepassport && this.$refs.filepassport.file){
                    this.$refs.filepassport.clearLocalFiles()
                }
            }
            this.ineFileFront = null
            this.ineFileBack = null
            this.passportFile = null
            this.uploadErrors = {}
        },
        fileDeleted(){
            this.disabledTypeFile = true
            this.updateModal()
        },
        onChangeDocument(documents){
            this.changeMode = true
            this.ID = documents.ID
        },
        onChangeBilling(mode){
        this.changeMode = mode
        },
        onChangeDirection(direction){
            this.changeMode = true
            this.address = direction.linea1
            this.address2 = direction.linea2
            this.country = direction.pais
            this.state = direction.estado
            this.city = direction.ciudad
            this.zipCode = direction.codigopostal
        },
        updateModal () {
            const { stateGuestEvent } = this.$store.state
            if(stateGuestEvent == 'edit'){
                let {
                    name,
                    phone,
                    email,
                    lastName,
                    country,
                    city,
                    state,
                    age,
                    address,
                    address2,
                    zipCode,
                    billing,
                    personalId,
                    personalIdType,
                    hasDocument,
                    documents,
                    curpMx
                } = this.bookData

                this.name     = name
                this.phone    = phone
                this.email    = email
                this.age      = age
                this.lastname = lastName
                this.country  = country
                this.city     = city
                this.state    = state
                this.address  = address
                this.address2 = address2
                this.zipCode  = zipCode
                this.ID = personalId
                this.typeFileSelection = personalIdType
                this.hasDocument = hasDocument
                this.fileId     = documents
                this.isMexican  = !!curpMx
                this.curp       = curpMx || ''
                this.billing = Object.keys(billing).length === 0 ? null : billing
                this.direccionData = {
                    country: country,
                    city: city,
                    state: state,
                    zipCode: zipCode,
                    address: address,
                    address2: address2
                }
                this.documentUpdate = {
                    ID: personalId,
                    typeFileSelection: personalIdType,
                    fileId: documents
                }
            }else {
                this.resetModal()
            }
        },
        resetModal () {
            this.name     = ''
            this.phone    = ''
            this.email    = ''
            this.age      = null
            this.lastname = ''
            this.country  = ''
            this.city     = ''
            this.state    = ''
            this.address  = ''
            this.address2 = ''
            this.zipCode  = ''
            this.hasDocument = false
            this.billing = null
            this.fileId = null
            this.isMexican = false
            this.curp = ''
        },
        async handleOk (bvModalEvt) {
            bvModalEvt.preventDefault()
            // Evita dos envíos simultáneos (doble clic) que crearían el huésped dos veces
            if(this.isSubmitting){
                return
            }
            this.isSubmitting = true
            try {
                var id = this.bookData.id
                const { stateGuestEvent } = this.$store.state
                let validate = await this.validateAll()
                if(validate){
                    await this.handleSubmit(id, stateGuestEvent)
                }
            } finally {
                this.isSubmitting = false
            }
        },
        uploadFile(guestId, file, type){
            let formData = new FormData();
            formData.append('files', file)
            formData.append('guestId', guestId)
            formData.append('type', type)
            return this.$root.authApi.post(`files`, formData)
        },
        pendingDocuments(){
            if(!this.changeModeFile){
                return []
            }
            const documents = this.typeFileSelection === 'ine_ife'
                ? [
                    { ref: 'fileIneFront', field: 'ineFileFront', type: 'ine-front' },
                    { ref: 'fileIneBack', field: 'ineFileBack', type: 'ine-back' },
                ]
                : [{ ref: 'filepassport', field: 'passportFile', type: 'passport' }]
            return documents
                .filter(doc => this[doc.field] != null && !this.uploadedTypes.includes(doc.type))
                .map(doc => ({ ...doc, file: this[doc.field] }))
        },
        // Sube los documentos pendientes y devuelve true solo si todos se guardaron.
        // Los que ya se subieron no se reenvían al reintentar.
        async saveFiles(guestId){
            const pending = this.pendingDocuments()
            const results = await Promise.allSettled(
                pending.map(doc => this.uploadFile(guestId, doc.file, doc.type))
            )

            const uploadErrors = { ...this.uploadErrors }
            const uploadedTypes = [...this.uploadedTypes]
            results.forEach((result, index) => {
                const doc = pending[index]
                if(result.status === 'fulfilled'){
                    uploadedTypes.push(doc.type)
                    uploadErrors[doc.ref] = null
                }else{
                    console.error(result.reason)
                    uploadErrors[doc.ref] = this.uploadErrorMessage(result.reason)
                }
            })
            this.uploadErrors = uploadErrors
            this.uploadedTypes = uploadedTypes
            return results.every(result => result.status === 'fulfilled')
        },
        uploadErrorMessage(err){
            if(!err || !err.response){
                return this.$t('fileUpload.errors.network')
            }
            const errorCode = err.response.data && err.response.data.errorCode
            if(!errorCode && err.response.status === 413){
                return this.$t('fileUpload.errors.fileTooLarge')
            }
            const key = `fileUpload.errors.${errorCode}`
            return errorCode && this.$te(key) ? this.$t(key) : this.$t('fileUpload.errors.generic')
        },
        resetUploadState(field){
            const refByField = { ineFileFront: 'fileIneFront', ineFileBack: 'fileIneBack', passportFile: 'filepassport' }
            const typeByField = { ineFileFront: 'ine-front', ineFileBack: 'ine-back', passportFile: 'passport' }
            this.uploadErrors = { ...this.uploadErrors, [refByField[field]]: null }
            this.uploadedTypes = this.uploadedTypes.filter(type => type !== typeByField[field])
        },
        onFocusValidate(validate){
            // 1. Loop the keys
            for (let key in Object.keys(validate.$v)) {
                // 2. Extract the input
                const input = Object.keys(validate.$v)[key];

                // 3. Remove special properties
                if (input.includes("$")) return false;

                // 4. Check for errors
                if (validate.$v[input].$error) {
                    // 5. Focus the input with the error
                    validate.$refs[input].focus();

                    // 6. Break out of the loop
                    break
                }
            }
        },
        validateAll(){
            this.isLoading = true
            if(this.$v.$invalid){
                this.$v.$touch()
                this.isLoading = false
                this.onFocusValidate(this)
                return false
            }if(this.$refs.direccionComponent.$v.$invalid){
                this.$refs.direccionComponent.$v.$touch()
                this.isLoading = false
                this.onFocusValidate(this.$refs.direccionComponent)
                return false
            }
            if(this.$refs.billingComponent.$v.status.$model){
                //verificamos que todos los datos requeridos esten
                if(!this.$refs.billingComponent.$v.$invalid && !this.$refs.billingComponent.$refs.direccionComponent.$v.$invalid){
                    //agregamos los datos del billing al objeto para guardarlo en el array
                    const {
                        ciudad,
                        clientCodeRfc,
                        selected,
                        codigopostal,
                        pais,
                        email,
                        nombreCompleto,
                        telefono,
                        estado,
                        linea1,
                        linea2
                    } = this.$refs.billingComponent

                    let obj = {
                        address: linea1,
                        address2: linea2,
                        city: ciudad,
                        country: pais,
                        email: email,
                        name: nombreCompleto,
                        phone: telefono,
                        state: estado,
                        zipCode: codigopostal,
                        rfc: clientCodeRfc,
                        businessName: selected
                    }
                    this.getBilling = obj
                }else{
                    this.$refs.billingComponent.$v.$touch()
                    this.$refs.billingComponent.$refs.direccionComponent.$v.$touch()
                    if(this.$refs.billingComponent.$v.$invalid){
                        this.isLoading = false
                        this.onFocusValidate(this.$refs.billingComponent)
                        return false
                    }
                    if(this.$refs.billingComponent.$refs.direccionComponent.$v.$invalid){
                        this.isLoading = false
                        this.onFocusValidate(this.$refs.billingComponent.$refs.direccionComponent)
                        return false
                    }
                }
            }
            if(this.$refs.documentSelection.$v.$invalid){
                this.$refs.documentSelection.$v.$touch()
                this.onFocusValidate(this.$refs.documentSelection)
                this.isLoading = false
                return false
            }
            if(this.requiredFieldsConfig.document){
                if(this.typeFileSelection === 'ine_ife'){
                    let found = false;
                    let found2 = false;
                    if(this.fileId){
                        for(let i = 0; i < this.fileId.length; i++) {
                            if (this.fileId[i].type == 'ine-front') {
                                found = true;
                            }else if (this.fileId[i].type == 'ine-back'){
                            found2 = true;
                            }
                        }
                    }

                    if(!found && this.ineFileFront == null){
                        this.$refs.fileIneFront.$v.$touch()
                        this.isLoading = false
                        return false
                    }else if(!found2 && this.ineFileBack == null){
                        this.$refs.fileIneBack.$v.$touch()
                        this.isLoading = false
                        return false
                    }
                }else if(this.typeFileSelection === 'pasaporte'){
                    let found = false;
                    if(this.fileId){
                        for(let i = 0; i < this.fileId.length; i++) {
                            if (this.fileId[i].type == 'passport') {
                                found = true;
                            }
                        }
                    }
                    if(!found && this.passportFile == null){
                        this.$refs.filepassport.$v.$touch()
                        this.isLoading = false
                        return false
                    }
                }
            }
            return true
        },
        // Devuelve true si la firma no aplica, ya estaba subida o se subió bien
        async saveSign(guestId) {
            const { minAgeSign, typeGuestSign } = this.$store.state.settings
            const signRequired = typeGuestSign !== 'owner_only' && this.age >= minAgeSign
            const sign = this.$store.state.sign
            if(!signRequired || !sign || this.signUploaded){
                return true
            }
            try {
                await this.uploadFile(guestId, sign, 'sign')
                this.signUploaded = true
                this.kill = true
                this.Firmar = 'Firmado'
                this.titleFooter = 'Finalizar Pre-CheckIn'
                return true
            } catch (err) {
                console.error(err)
                this.submitError = this.$t('fileUpload.errors.signFailed', { reason: this.uploadErrorMessage(err) })
                return false
            }
        },
        buildGuestData(){
            return {
                name: this.name,
                lastName: this.lastname,
                phone: this.phone,
                email: this.email,
                age: this.age,
                title: 'title',
                country: this.country,
                state: this.state,
                city: this.city,
                address: this.address,
                address2: this.address2,
                zipCode: this.zipCode,
                personalId: this.ID,
                personalIdType: this.typeFileSelection,
                billing: this.getBilling,
                requireBilling: this.$refs.billingComponent.$v.status.$model ? true : false,
                ...(this.$store.state.settings.showCurpMx && this.isMexican ? { curpMx: this.curp.toUpperCase() } : {})
            }
        },
        async requestGuestSave(request){
            const res = await request
            if(res.status != 200){
                throw new Error(`Unexpected status ${res.status} saving guest`)
            }
            return res
        },
        // Guarda el huésped con las mismas rutas de siempre (create / edit / titular).
        // Devuelve { guestId, uploadSign } o null si no había nada que guardar.
        async persistGuest(id, stateGuestEvent, data){
            if(this.savedGuest){
                // Reintento después de un archivo fallido: se actualiza el mismo huésped
                await this.requestGuestSave(this.$root.authApi.put(`guests?id=${this.savedGuest.guestId}`, data))
                return this.savedGuest
            }

            let guestId = id
            let wasUpdated = false
            if(this.changeMode){
                if(stateGuestEvent == 'create'){
                    const res = await this.requestGuestSave(this.$root.authApi.post('guests', { ...data, bookId: this.getBookId }))
                    if(res.data !== ""){
                        guestId = res.data.guestId
                        localStorage.setItem("idNewGuest", guestId)
                    }
                    return { guestId, uploadSign: true }
                }
                if(stateGuestEvent == 'edit' || localStorage.getItem('idNewGuest')){
                    const res = await this.requestGuestSave(this.$root.authApi.put(`guests?id=${id}`, data))
                    if(res.data !== ""){
                        guestId = res.data.guestId
                    }else{
                        localStorage.setItem("idNewGuest", id)
                    }
                    wasUpdated = true
                }
            }

            if(stateGuestEvent == 'edit'){
                if(this.$store.state.owner){
                    const { reservation } = this.$store.state
                    const ownerData = { ...data, bookId: this.getBookId, clientId: reservation.clientId }
                    const res = await this.requestGuestSave(this.$root.authApi.post(`guests`, ownerData))
                    if(res.data !== ""){
                        guestId = res.data.guestId
                    }else{
                        localStorage.setItem("idNewGuest", id)
                    }
                }
                return { guestId, uploadSign: true }
            }
            return wasUpdated ? { guestId, uploadSign: false } : null
        },
        // El modal solo se cierra cuando el huésped, la firma y los documentos se guardaron
        async handleSubmit(id, stateGuestEvent){
            this.submitError = null
            this.isLoading = true
            try {
                const savedGuest = await this.persistGuest(id, stateGuestEvent, this.buildGuestData())
                if(!savedGuest){
                    return
                }
                this.savedGuest = savedGuest

                const signSaved = savedGuest.uploadSign ? await this.saveSign(savedGuest.guestId) : true
                const filesSaved = await this.saveFiles(savedGuest.guestId)
                if(signSaved && filesSaved){
                    this.$bvModal.hide('modal-1')
                }
            } catch (err) {
                console.error(err)
                this.submitError = this.$t('fileUpload.errors.guestSaveFailed')
            } finally {
                this.isLoading = false
            }
        }
    },
    created: function(){
        this.updateModal()
    },
    mounted(){
        if(this.billing){
            if(Object.keys(this.billing).length !== 0){
                this.$refs.billingComponent.asignDataBilling()
                this.$refs.billingComponent.status = true
            }
        }
    },
    updated: function(){
        if(this.billing){
            if(Object.keys(this.billing).length !== 0){
                this.$refs.billingComponent.asignDataBilling()
                this.$refs.billingComponent.status = true
            }
        }
    }
}
</script>

<style scoped>

</style>
